import React from "react";

import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";

import { cn } from "@/lib/utils";
import { REFERENCE_DELIMITER } from "@/constants/defaultValue";

import MessageTime from "./MessageTime";

function UserMessage({ message, isPopupContent }) {
  const splitMessage = (content) => {
    if (!content.includes(REFERENCE_DELIMITER)) return { reference: null, message: content };
    const [reference, msg] = content.split(REFERENCE_DELIMITER);
    return { reference, message: msg };
  };
  const { reference, message: userMessage } = splitMessage(message.content);
  return (
    <div className="flex mt-4 justify-end">
      <div className={cn("inline-block max-w-[95%] rounded-lg rounded-br-none bg-white text-black border border-[#E7EDF4]", isPopupContent ? "p-2" : "p-3")}>
        {reference && (
          <div className="mb-3 pl-3 py-3 bg-gradient-to-r from-gray-50 to-gray-100 rounded-lg border border-gray-200 shadow-sm">
            <div className="max-h-[200px] overflow-y-auto pr-2 custom-scrollbar">
              <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]} className={cn(isPopupContent ? "text-xs" : "text-sm", "text-gray-700 leading-relaxed")}>
                {reference}
              </ReactMarkdown>
            </div>
          </div>
        )}
        <span className={cn(isPopupContent ? "text-sm" : "text-md")}>{userMessage}</span>
        <MessageTime timestamp={message.createTime} className={cn("text-left")} />
      </div>
    </div>
  );
}

export default UserMessage;
